module.exports = __webpack_public_path__ + "img/cow3.2d101133.png";